module.exports = __webpack_public_path__ + "static/logo-main-186a817fb35bcae0b4dac697218235e3.png";